import { type SectionConfig } from '@/utils/get-matched-section'

export const sectionConfig: SectionConfig = {
  '/dispatching/dashboard': {
    title: 'Dispatch Dashboard',
    showBreadcrumbs: false
  },
  '/dispatching/map': {
    // The map IS the page: no page padding, no ScrollArea, own full height.
    fullBleed: true,
    title: 'Map'
  },
  '/dispatching/work-orders': {
    title: 'Work Orders'
  },
  '/dispatching/work-order-requests': {
    title: 'Work Order Requests'
  },
  '/dispatching/tasks': {
    title: 'Work Order Tasks'
  },
  '/dispatching/work-orders/[workOrderId]': {
    title: (params) => {
      const p = params as { workOrderId?: string }
      return p?.workOrderId ? `${p.workOrderId}` : 'Work Order'
    },
    parentBreadcrumb: {
      label: 'Work Orders',
      href: (_params, orgSlug) => `/${orgSlug}/dispatching/work-orders`
    }
  },
  '/dispatching/work-orders/[workOrderId]/tasks/[taskId]': {
    title: (params) => {
      const p = params as { taskId?: string }
      return p?.taskId ? `${p.taskId}` : 'Task'
    },
    parentBreadcrumb: [
      {
        label: 'Work Orders',
        href: (_params, orgSlug) => `/${orgSlug}/dispatching/work-orders`
      },
      {
        label: (params) => {
          const p = params as { workOrderId?: string }
          return p?.workOrderId || 'Work Order'
        },
        href: (params, orgSlug) => {
          const p = params as { workOrderId?: string }
          return `/${orgSlug}/dispatching/work-orders/${p?.workOrderId || ''}`
        }
      }
    ]
  },
  '/dispatching/parts-readiness': {
    title: 'Parts readiness'
  },
  '/dispatching/technicians': {
    title: 'Technicians'
  },
  '/dispatching/technicians/[techId]': {
    title: (params) => {
      const p = params as { techId?: string }
      return p?.techId ? `${p.techId}` : 'Technician'
    },
    parentBreadcrumb: {
      label: 'Technicians',
      href: (_params, orgSlug) => `/${orgSlug}/dispatching/technicians`
    }
  },
  '/dispatching/technician-companies': {
    title: 'Technician Companies'
  },
  '/dispatching/technician-companies/new': {
    title: 'Onboard Technician Company',
    parentBreadcrumb: {
      label: 'Technician Companies',
      href: (_params, orgSlug) => `/${orgSlug}/dispatching/technician-companies`
    }
  },
  '/dispatching/onboarding': {
    title: 'Technician Onboarding',
    description:
      'Companies onboarding through the link: forms, signed agreements, and the Accounting and Field Ops approvals.'
  },
  '/dispatching/onboarding/[journeyId]': {
    title: 'Onboarding review',
    parentBreadcrumb: {
      label: 'Technician Onboarding',
      href: (_params, orgSlug) => `/${orgSlug}/dispatching/onboarding`
    }
  },
  '/dispatching/onboarding/[journeyId]/approve': {
    title: 'Approve',
    parentBreadcrumb: {
      label: 'Onboarding review',
      href: (params, orgSlug) =>
        `/${orgSlug}/dispatching/onboarding/${(params as { journeyId?: string }).journeyId ?? ''}`
    }
  },
  '/dispatching/schedule': {
    title: 'Schedule'
  },
  '/dispatching/capture-review': {
    title: 'Capture Review',
    description:
      'Field captures and registered installs waiting on a reviewer: accept them, or send them back with a note.',
    showBreadcrumbs: false
  },
  '/dispatching/site-data': {
    title: 'Field Data',
    description:
      'What technicians measured and photographed at a property: speed tests by floor, Wi-Fi and RF readings, cable tests.',
    showBreadcrumbs: false
  },
  '/dispatching/site-data/[customerId]': {
    title: 'Field Data',
    parentBreadcrumb: {
      label: 'Field Data',
      href: (_params, orgSlug) => `/${orgSlug}/dispatching/site-data`
    }
  },
  '/dispatching/visit-qa': {
    title: 'Visit QA',
    description:
      'Recent visits that ended with the property still showing problems: what to add to a capture template or checklist.',
    showBreadcrumbs: false
  },
  '/dispatching/capture-templates': {
    title: 'Capture Templates',
    description:
      'Which data technicians must capture on site for each type of work, and the rules that assign a template to a task.',
    showBreadcrumbs: false
  },
  '/dispatching/capture-templates/[key]': {
    title: (params) => {
      const p = params as { key?: string }
      return p?.key ?? 'Template'
    },
    parentBreadcrumb: {
      label: 'Capture Templates',
      href: (_params, orgSlug) => `/${orgSlug}/dispatching/capture-templates`
    }
  }
}
